import { useEffect, useState } from 'react';
import { Box, Paper, Typography, CircularProgress, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SecurityIcon from '@mui/icons-material/Security';

export function VerifyEmailPage() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('驗證連結無效，缺少 token。');
      return;
    }

    fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setStatus('success');
          setMessage('電子郵件驗證成功！您現在可以登入了。');
        } else {
          setStatus('error');
          setMessage(data.error || '驗證失敗，連結可能已過期。');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('網路錯誤，請稍後再試。');
      });
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Paper sx={{ p: 4, width: 400, maxWidth: '95vw', textAlign: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
          <SecurityIcon color="primary" />
          <Typography variant="h5" fontWeight="bold">PQC Navigator</Typography>
        </Box>

        {status === 'loading' && (
          <Box>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography color="text.secondary">驗證中，請稍候...</Typography>
          </Box>
        )}

        {status === 'success' && (
          <Box>
            <CheckCircleIcon sx={{ fontSize: 56, color: '#388e3c', mb: 2 }} />
            <Typography variant="h6" color="success.main" gutterBottom>驗證成功</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
            <Button variant="contained" href="/" size="large" fullWidth>前往登入</Button>
          </Box>
        )}

        {status === 'error' && (
          <Box>
            <ErrorIcon sx={{ fontSize: 56, color: '#d32f2f', mb: 2 }} />
            <Typography variant="h6" color="error" gutterBottom>驗證失敗</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{message}</Typography>
            <Button variant="outlined" href="/" size="large" fullWidth>返回首頁</Button>
          </Box>
        )}
      </Paper>
    </Box>
  );
}
